import * as React from 'react';
import { SettingsPanelHOC } from '../../../../../listView/hocs/SettingsPanelHOC/SettingsPanelHOC';

export const getListViewSettingsBody = (): JSX.Element => {
    return <SettingsPanelHOC />;
};
